import { render, staticRenderFns } from "./ListDomains.vue?vue&type=template&id=62a5941a&scoped=true"
import script from "./ListDomains.vue?vue&type=script&lang=js"
export * from "./ListDomains.vue?vue&type=script&lang=js"
import style0 from "./ListDomains.vue?vue&type=style&index=0&id=62a5941a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62a5941a",
  null
  
)

export default component.exports